@if (componentRegistry.loading()) {
<div role="status" class="fixed right-3 bottom-3 z-[100000] rounded bg-white px-4 py-2 text-sm shadow">
	{{ Dic.screenloading.text === 'screenloading' ? 'Chargement de l’écran…' : Dic.screenloading.text }}
</div>
}
<!-- ----- Écran de démarrage : recouvre le shell tant que topbar et sidebar chargent -->
@if (!shellReady()) {
<ui-loading type="fullscreen" variant="icon" size="large" />
}

<div class="app-shell flex flex-row h-screen">
	<div
		class="app-shell__sidebar flex-shrink-0 h-full overflow-hidden"
		[class]="
      sidebar.isOpen()
        ? 'fixed md:relative z-50 md:z-auto w-full md:w-[var(--shell-sidebar-w)]'
        : 'w-0 md:w-[var(--shell-sidebar-mini-w)] relative'
    ">
		<layout-sidebar />
	</div>

	<div class="app-shell__main flex flex-col flex-1 overflow-hidden">
		<layout-topbar />
		<app-dictkeyedit />

		@if (sidebar.isOpen()) {
		<div class="app-shell__backdrop fixed inset-0 z-40 md:hidden" (click)="sidebar.toggle()"></div>
		}

		<div class="app-shell__content flex-1 overflow-auto">
			<div class="h-full">
				@if (currentView()) {
				<app-databrowser />
				} @else if (componentLoading()) {
				<ui-loading type="component" />
				} @else if (dynamicComponent()) {
				<ng-container *ngComponentOutlet="dynamicComponent()" />
				}
			</div>
		</div>
	</div>
</div>

<myap-livekit />

<ui-toast />

<p-confirmDialog
	key="missing-component-dialog"
	styleClass="missing-component-confirm-dialog"
	appendTo="body"
	[draggable]="false"
	[dismissableMask]="true"
	[closeOnEscape]="true" />

<p-confirmDialog
	key="unsaved-dialog"
	appendTo="body"
	[baseZIndex]="100000"
	[draggable]="false"
	[closable]="false"
	[dismissableMask]="false"
	[closeOnEscape]="false" />

@for (dialog of moduleService.dialogs(); track dialog.id) {
<ui-dialog
	[visible]="true"
	(visibleChange)="moduleService.setDialogVisible(dialog.id, $event)"
	(activate)="moduleService.activateDialog(dialog.id)"
	(save)="moduleService.triggerDialogSave(dialog.id)"
	(cancel)="moduleService.triggerDialogCancel(dialog.id)"
	(close)="moduleService.triggerDialogClose(dialog.id)"
	(refresh)="moduleService.triggerDialogRefresh(dialog.id)"
	(previous)="moduleService.triggerDialogPrevious(dialog.id)"
	(next)="moduleService.triggerDialogNext(dialog.id)"
	[header]="dialog.header"
	[subheader]="dialog.subheader"
	[headerIcon]="dialog.headerIcon"
	[headerLucideIcon]="dialog.headerLucideIcon"
	[showHeader]="dialog.showHeader"
	[modal]="dialog.modal"
	[dirty]="dialog.dirty"
	[actions]="dialog.actions"
	(action)="moduleService.triggerDialogAction(dialog.id, $event)"
	[loading]="dialog.loading"
	[baseZIndex]="dialog.zIndex"
	[showRefreshButton]="dialog.showRefreshButton"
	[showNavigateButtons]="dialog.showNavigateButtons"
	[canNavigatePrevious]="dialog.canNavigatePrevious"
	[canNavigateNext]="dialog.canNavigateNext"
	[showFooter]="dialog.showFooter"
	[footerSummary]="dialog.footerSummary"
	[footerTemplate]="dialog.footerTemplate"
	[saveLabel]="dialog.saveLabel"
	[saveLabelKey]="dialog.saveLabelKey"
	[cancelLabel]="dialog.cancelLabel"
	[cancelLabelKey]="dialog.cancelLabelKey"
	[dirtyCancelLabel]="dialog.dirtyCancelLabel"
	[dirtyCancelLabelKey]="dialog.dirtyCancelLabelKey"
	[closeButton]="dialog.closeButton"
	[saveSeverity]="dialog.saveSeverity"
	[cancelSeverity]="dialog.cancelSeverity"
	[closable]="dialog.closable"
	[saveDisabled]="dialog.saveDisabled"
	[desktopWidth]="dialog.width"
	[desktopMinWidth]="dialog.minWidth"
	[desktopMaxWidth]="dialog.maxWidth"
	[desktopHeight]="dialog.height"
	[desktopMinHeight]="dialog.minHeight"
	[desktopMaxHeight]="dialog.maxHeight">
	@if (dialog.component) {
	<ng-container *ngComponentOutlet="dialog.component; inputs: dialog.inputs" />
	}
</ui-dialog>
}
